<script setup lang="ts">
	// interface
	interface Props {
		width?: string
		height?: string
		border?: boolean
		circular?: boolean
	}

	// props
	withDefaults(defineProps<Props>(), {
		width: 'w-full',
		height: 'h-full',
		border: true,
		circular: false
	})
</script>

<template>
	<div
		class="skeleton bg-purple-100"
		:class="{
			rounded: border,
			[width]: width,
			[height]: height,
			'rounded-full': circular
		}"
	></div>
</template>

<style scoped>
	.skeleton {
		background-image: linear-gradient(
			90deg,
			rgba(255, 255, 255, 0),
			rgba(255, 255, 255, 0.5),
			rgba(255, 255, 255, 0)
		);
		background-size: 40px 100%;
		background-repeat: no-repeat;
		background-position: left -40px top 0;
		animation: shine 1s ease infinite;
	}

	@keyframes shine {
		to {
			background-position: right -20px top 0;
		}
	}
</style>
